import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../../../../../common/config';
import useAnimation from './useAnimation';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

const Nutrition = styled.div`
  padding-top: 60rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Info = styled.div`
  margin: 10rem 0;
  display: flex;
  flex-direction: column;

  &:last-child { padding-bottom: 20rem }
  label { font-weight: bold }
`;

const Content = ({ calorie, taste, aroma, pairsWell, active }: {
  calorie: string,
  taste: string,
  aroma: string,
  pairsWell: string[],
  active: boolean
}) => {

  const ref = {
    wrapper: useRef<HTMLDivElement>(null),
    calorie: useRef<HTMLDivElement>(null),
    taste: useRef<HTMLDivElement>(null),
    aroma: useRef<HTMLDivElement>(null),
    pairs: useRef<HTMLDivElement>(null)
  }

  useAnimation(ref.wrapper, [
    ref.calorie,
    ref.taste,
    ref.aroma,
    ref.pairs
  ], active);

  return (
    <Wrapper ref={ref.wrapper}>
      <Nutrition ref={ref.calorie}>
        <p>{calorie} kJ/kcal (100ml)</p>
        <p>4.5% ABV</p>
      </Nutrition>

      <Info ref={ref.taste}>
        <label>Taste</label>
        <p>{taste}</p>
      </Info>

      <Info ref={ref.aroma}>
        <label>Aroma</label>
        <p>{aroma}</p>
      </Info>

      <Info ref={ref.pairs}>
        <label>Pairs well with</label>
        <p>{pairsWell.join(", ")}</p>
      </Info>
    </Wrapper>
  );
}

export default Content;